"use client";

import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function FinalCtaOrleans() {
  const [scrollY, setScrollY] = useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="235468" id="final-cta-orleans" className="bg-background text-foreground relative flex min-h-[80vh] items-center justify-center overflow-hidden py-32 md:py-48">
      {}
      <div className="absolute -inset-[50%] -z-20 opacity-90" style={{
      backgroundImage: "linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%)",
      transform: `translateY(${scrollY * 0.15}px)`,
      transition: "transform 0.1s ease-out"
    }} />

      {}
      <div className="absolute inset-0 -z-10 mix-blend-overlay opacity-[0.15] pointer-events-none" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
    }} />

      {}
      <div ref={ref} className={`container relative z-10 mx-auto px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        <h2 className="font-default mb-6 text-7xl font-bold leading-none tracking-tighter text-white drop-shadow-2xl md:text-9xl lg:text-[12rem]">
          Ready?
        </h2>
        
        <p className="mb-12 max-w-3xl mx-auto text-xl font-default font-medium text-white/90 drop-shadow-md md:text-3xl">
          Book fast, affordable junk removal in Orleans today and reclaim your space.
        </p>

        <Button asChild size="lg" className="h-auto rounded-lg bg-secondary px-10 py-8 text-lg font-default font-bold text-secondary-foreground shadow-2xl transition-all duration-300 hover:scale-105 hover:bg-secondary/90 hover:shadow-secondary/25 md:text-xl">
          <Link to="/PricingPage">
            Get a Free Quote <ArrowRight className="ml-2 size-6" />
          </Link>
        </Button>
      </div>
    </section>;
}